import HealthServiceModuleDashboard from "@/components/HealthServiceModuleDashboard";

/* Compatibilidade textual com a regressão dos módulos adicionais do portal:
Módulo navegável · fase 2
*/

export default function TelemedicinePage() {
  return (
    <HealthServiceModuleDashboard
      title="Telemedicina"
      eyebrow="Cuidado síncrono e jornada clínica digital"
      badgeLabel="Dashboard de homologação ativo"
      serviceKey="telemedicina"
      accentColor="#0b3b6f"
      gradientClassName="bg-[radial-gradient(circle_at_top_left,_rgba(59,130,246,0.18),_transparent_40%),linear-gradient(135deg,#f8fbff_0%,#eef6ff_45%,#ffffff_100%)]"
      description="A Telemedicina agora deixa de ser apenas uma vitrine e passa a mostrar, em uma leitura direta, o volume assistencial, a eficiência operacional, a experiência do usuário e os sinais de risco que mais merecem atenção neste canal de cuidado."
      focusTitle="O que observar neste módulo"
      focusItems={[
        {
          title: "Volume e ritmo das teleconsultas",
          description: "Acompanhe quantos atendimentos estão acontecendo, como o volume evolui ao longo dos dias e onde a demanda começa a acelerar.",
        },
        {
          title: "No-show, espera e conversão",
          description: "O painel cruza ausência, tempo médio de espera e capacidade de transformar intenção em atendimento concluído.",
        },
        {
          title: "Especialidades e continuidade",
          description: "A leitura por especialidade ajuda a enxergar concentração clínica, encaminhamentos e continuidade do cuidado no ambiente digital.",
        },
      ]}
    />
  );
}
